import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import CrmInternalActivityStore from 'stores/crm-opp-ui/CrmInternalActivityStore';
import CrmInternalActivityActions from 'actions/crm-opp-ui/CrmInternalActivityActions';
import CallCardDetailsDialog from 'components/pure/call-card/CallCardDetailsDialog';
import SearchFieldsStore from 'stores/search/SearchFieldsStore';
import {newCallCardDetails} from 'components/pure/call-card/NewCallCardDetails';

class CallCardDetailsDialogContainer extends React.PureComponent {
  static getStores() {
    return [CrmInternalActivityStore, SearchFieldsStore];
  }

  static getPropsFromStores(props) {
    const store = CrmInternalActivityStore.getState();
    const searchFields = SearchFieldsStore.getState().get('fullSearchFields');
    return {
      activity: store.activity,
      activityLoading: store.activityLoading,
      activityLoaded: store.activityLoaded,
      callDetails: props.callDetails ?? newCallCardDetails(props.call, searchFields),
    };
  }

  componentDidMount() {
    CrmInternalActivityActions.fetchActivity.defer(this.props.fileUploadId);
  }

  componentWillUnmount() {
    CrmInternalActivityActions.clearActivity.defer();
  }

  render() {
    if (!this.props.callDetails) {
      return null;
    }

    return <CallCardDetailsDialog {...this.props} />;
  }
}

export default connectToStores(CallCardDetailsDialogContainer);
